const searchTagsFormatter = (object, isMedia) => {
  const tags = []
  for (let i in object) {
    if (i.includes(isMedia ? 'mediaTags[' : 'tags[')) {
      tags.push(object[i])
    }
  }
  return tags
}

export default searchTagsFormatter
